<template>
  <div>
    <BaseEmploymentsTable
      ref="tableRef"
      data-test="employments-onboarded-table"
      :query="query"
      :is-onboarded="true"
      :is-active-tab="isActiveTab"
      :bulk-actions="bulkActions"
    >
      <template #action="{ row }">
        <EmploymentActionColumnOnboarded :row="row" />
      </template>
    </BaseEmploymentsTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { TypedQueryDocumentNode } from 'graphql/index'
import BaseEmploymentsTable from './BaseEmploymentsTable.vue'
import { DataTableBulkAction } from '@/components/GraphqlDataTable/types'
import { graphql } from '@/gql'
import EmploymentActionColumnOnboarded from '@/components/GraphqlDataTable/columns/Employment/Partner/EmploymentActionColumnOnboarded.vue'

defineProps<{ isActiveTab?: boolean }>()

const query = graphql(`
  query PartnerEmploymentsOnboardedQuery(
    $accounts: [ID!]
    $search: String
    $first: Int!
    $page: Int
    $orderBy: [EmploymentsOrderByClauseInput!]
    $startDateRange: DateRangeInput
    $endDateRange: DateRangeInput
    $hiringManagers: [ID!]
    $assignmentCompanies: [ID!]
    $locations: [String!]
  ) {
    employments(
      accounts: $accounts
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
      startDateRange: $startDateRange
      endDateRange: $endDateRange
      hiringManagers: $hiringManagers
      companies: $assignmentCompanies
      locations: $locations
      employerRecordStatus: [COMPLETE]
    ) {
      data {
        ...EmploymentOnboardedDateColumn
        ...EmploymentWorkerColumn
        ...EmploymentJobColumn
        ...EmploymentContractColumn
        ...EmploymentLocationColumn
        ...EmploymentStartDateColumn
        ...EmploymentEndDateColumn
        ...EmploymentHiringManagerColumn
        ...EmploymentAssignmentCompanyColumn
        ...EmploymentActionColumnOnboarded
      }
    }
  }
`) as TypedQueryDocumentNode

const tableRef = ref<InstanceType<typeof BaseEmploymentsTable> | null>(null)

const bulkActions: DataTableBulkAction[] = []
</script>

<style scoped></style>
